export default __webpack_public_path__ + "static/media/img-as-02.c2daa564.png";